<style lang="less">
    .insertBlock-modal {
        width: 355px;
        height: 230px;
        .insertBlock-checkboxGroup {
            padding: 10px 20px;
            .insertBlock-checkbox {
                width: 45%;
                margin-bottom: 10px;
            }
        }
    }
</style>

<style lang="stylus">
    .insertBlock-mask
        .dialog-btnbox-normal
            border none
</style>

<template>
    <div class="modifyBlock-mask">
        <Dialog class="insertBlock-modal" :title="$t('InsertBlock.title')" :isShow="true" :mask="true" @close="closeModal">
            <CheckboxGroup v-model="type" vertical class="insertBlock-checkboxGroup">
                <Checkbox v-for="item in typeList" :key="item.id" :label="item.type" class="insertBlock-checkbox" :disabled="flags[item.id]">
                    <span>{{ $t(item.text) }}</span>
                </Checkbox>
            </CheckboxGroup>
            <div class="dialog-btnbox-normal">
                <div class="dialog-btn-ok" @click="modify()">{{ $t("confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    @Component({
        components: {
            Dialog,
        },
    })
    export default class modifyBlock extends Vue {
        type: Array<number> = [];
        typeList: Array<Object> = [];

        modify() {
            let view = window["_view"];
            if (view) {
                view.addBlocks(this.type);
                view.getActiveData();
            }
            this.closeModal();
        }

        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }

        initData() {
            this.typeList = [
                {
                    id: 0,
                    type: this.Block_Type.Actions,
                    text: "InsertBlock.Actions",
                },
                {
                    id: 1,
                    type: this.Block_Type.Connection_Points,
                    text: "InsertBlock.CPoints",
                },
                {
                    id: 2,
                    type: this.Block_Type.Text_Blocks,
                    text: "InsertBlock.Text",
                },
                {
                    id: 3,
                    type: this.Block_Type.Controls,
                    text: "InsertBlock.Controls",
                },
                {
                    id: 4,
                    type: this.Block_Type.Variants,
                    text: "InsertBlock.Variants",
                },
                {
                    id: 5,
                    type: this.Block_Type.Custom_Properties,
                    text: "InsertBlock.Custom",
                },
                {
                    id: 6,
                    type: this.Block_Type.Numbers,
                    text: "InsertBlock.Numbers",
                },
                {
                    id: 7,
                    type: this.Block_Type.Geometry,
                    text: "InsertBlock.Geometry",
                },
            ];
        }

        get flags() {
            return this.$store.state.ui.insertBlock;
        }

        get Block_Type() {
            return this.$store.state.datasheet.Block_Type;
        }

        mounted() {
            this.type = [];
        }

        created() {
            this.initData();
        }
    }
</script>
<i18n>
{
  "zh": {
    "InsertBlock": {
      "title": "插入块",
      "Actions": "动作",
      "CPoints": "连接点",
      "Text": "文本",
      "Controls": "控制点",
      "Variants": "变量",
      "Custom": "自定义属性",
      "Numbers": "数字",
      "Geometry": "几何数据"
    },
    "confirm": "插入",
    "cancel": "取消"
  },
  "fr": {
    "InsertBlock": {
      "title": "Insérer Bloc",
      "Actions": "Actions",
      "CPoints": "Points de Connexion",
      "Text": "Text",
      "Controls": "Contrôle",
      "Variants": "Variante",
      "Custom": "Propriétés personnalisées",
      "Numbers": "Nombres",
      "Geometry": "Géométrie"
    },
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "de": {
    "InsertBlock": {
      "title": "Block einfügen",
      "Actions": "Aktionen",
      "CPoints": "Verbindungspunkt",
      "Text": "Text",
      "Controls": "Kontrolle",
      "Variants": "Variante",
      "Custom": "Benutzerdefiniert",
      "Numbers": "Zahlen",
      "Geometry": "Geometrie"
    },
    "confirm": "Sichern",
    "cancel": "Abbrechen"
  },
  "en": {
    "InsertBlock": {
      "title": "Insert Block",
      "Actions": "Actions",
      "CPoints": "Connection Points",
      "Text": "Text",
      "Controls": "Controls",
      "Variants": "Variants",
      "Custom": "Custom Properties",
      "Numbers": "Numbers",
      "Geometry": "Geometry"
    },
    "confirm": "Insert",
    "cancel": "Cancel"
  },
  "jp": {
    "InsertBlock": {
      "title": "ブロックを挿入",
      "Actions": "操作",
      "CPoints": "接続ポイント",
      "Text": "テキスト",
      "Controls": "コントロールポイント",
      "Variants": "変量",
      "Custom": "属性をカスタマイズ",
      "Numbers": "数字",
      "Geometry": "幾何学データ"
    },
    "confirm": "挿入",
    "cancel": "キャンセル"
  },
  "es": {
    "InsertBlock": {
      "title": "Insertar bloque",
      "Actions": "Acciones",
      "CPoints": "Puntos de conexión",
      "Text": "Texto",
      "Controls": "Controles",
      "Variants": "Variantes",
      "Custom": "Propiedades personalizadas",
      "Numbers": "Números",
      "Geometry": "Geometría"
    },
    "confirm": "Aceptar",
    "cancel": "Cancelar"
  },
  "pt": {
    "InsertBlock": {
      "title": "Inserir Bloco",
      "Actions": "Ações",
      "CPoints": "Pontos de Conexão",
      "Text": "Texto",
      "Controls": "Controles",
      "Variants": "Variantes",
      "Custom": "Propriedades Personalizadas",
      "Numbers": "Números",
      "Geometry": "Geometria"
    },
    "confirm": "inserir",
    "cancel": "Cancelar"
  },
  "it": {
    "InsertBlock": {
      "title": "Inserimento Blocco",
      "Actions": "Azioni",
      "CPoints": "Punti di Connessione",
      "Text": "Testo",
      "Controls": "Controlli",
      "Variants": "Varianti",
      "Custom": "Proprietà Personalizzate",
      "Numbers": "Numeri",
      "Geometry": "Geometria"
    },
    "confirm": "inserisci",
    "cancel": "Annulla"
  },
  "tw": {
    "InsertBlock": {
      "title": "插入塊",
      "Actions": "動作",
      "CPoints": "連接點",
      "Text": "文本",
      "Controls": "控制點",
      "Variants": "變量",
      "Custom": "自定義屬性",
      "Numbers": "數字",
      "Geometry": "幾何數據"
    },
    "confirm": "插入",
    "cancel": "取消"
  },
  "kr": {
    "InsertBlock": {
      "title": "블록 삽입",
      "Actions": "액션",
      "CPoints": "접속 포인트",
      "Text": "텍스트",
      "Controls": "제어점",
      "Variants": "변량",
      "Custom": "사용자 지정 속성",
      "Numbers": "숫자",
      "Geometry": "기하학적 데이터"
    },
    "confirm": "삽입",
    "cancel": "취소"
  }
}
</i18n>
